"use strict";

module.exports = triangulateCube;

var perm = require("permutation-rank");

var sgn = require("permutation-parity");

var gamma = require("gamma");

function triangulateCube(dimension) {
  if (dimension < 0) {
    return [];
  }

  if (dimension === 0) {
    return [[0]];
  }

  var dfactorial = Math.round(gamma(dimension + 1)) | 0;
  var result = [];

  for (var i = 0; i < dfactorial; ++i) {
    var p = perm.unrank(dimension, i);
    var cell = [0];
    var v = 0;

    for (var j = 0; j < p.length; ++j) {
      v += 1 << p[j];
      cell.push(v);
    }

    if (sgn(p) < 1) {
      cell[0] = v;
      cell[dimension] = 0;
    }

    result.push(cell);
  }

  return result;
}